/**
 * Shared plan configuration for Billing and Checkout pages.
 * Benefits and pricing aligned with backend plans.js.
 */
export const PLANS = [
  {
    planId: "free",
    name: "Free Trial",
    price: 0,
    priceDisplay: "$0",
    period: "per month",
    benefits: [
      "1 call included",
      "45 min max call duration",
      "AI analysis & scores",
      "Email reports",
    ],
    isPaid: false,
  },
  {
    planId: "starter",
    name: "Starter",
    price: 49,
    priceDisplay: "$49",
    period: "per seat / month",
    benefits: [
      "10 calls per seat",
      "90 min max call duration",
      "Overage $4/call",
      "Per-seat billing",
    ],
    isPaid: true,
  },
  {
    planId: "pro",
    name: "Pro",
    price: 99,
    priceDisplay: "$99",
    period: "per seat / month",
    benefits: [
      "25 calls per seat",
      "90 min max call duration",
      "Overage $3/call",
      "Per-seat billing",
    ],
    isPaid: true,
  },
  {
    planId: "teams",
    name: "Teams",
    price: 199,
    priceDisplay: "$199",
    period: "per month",
    benefits: [
      "75 calls team pool",
      "5 seats included",
      "90 min max call duration",
      "Overage $2.50/call & extra seats $35/ea",
    ],
    isPaid: true,
  },
];

export const PAID_PLAN_IDS = ["starter", "pro", "teams"];

export function getPlanById(planId) {
  return PLANS.find((p) => p.planId === planId) || null;
}
